module.exports = __webpack_public_path__ + "img/guzhenTop.d1d46890.jpg";